import * as Comlink from 'comlink'
import { SolverWorker } from './worker'
import { Puzzle, PuzzleAttempt } from './puzzle';
import { SolvePuzzleResult } from './solver';

const worker = new Worker("./build/worker.js");
const solver = Comlink.wrap<SolverWorker>(worker);

export function genPuzzle(width: number, height: number, difficulty: number): Promise<Puzzle> {
    return solver.genPuzzle(width, height, difficulty)
}

export async function solvePuzzle(attempt: PuzzleAttempt, maxSteps: number = null, maxDifficulty: number = 5): Promise<SolvePuzzleResult> {
    let res = await solver.solvePuzzle(attempt, maxSteps, maxDifficulty);
    //our instance doesn't survive serialization, so we recreate the attempt on this side of the worker
    res.solution = new PuzzleAttempt(res.solution.puzzle, res.solution)
    return res;
}